import { render, staticRenderFns } from "./SmsEmailCertn.vue?vue&type=template&id=9c4917c0"
import script from "./SmsEmailCertn.vue?vue&type=script&lang=js"
export * from "./SmsEmailCertn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c4917c0')) {
      api.createRecord('9c4917c0', component.options)
    } else {
      api.reload('9c4917c0', component.options)
    }
    module.hot.accept("./SmsEmailCertn.vue?vue&type=template&id=9c4917c0", function () {
      api.rerender('9c4917c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/auth/SmsEmailCertn.vue"
export default component.exports